module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_Blanqueado_Mitad.4f86cd31.pdf";